// Models
import Model from './Model'
import TierWatchdogRule from './TierWatchdogRule'

class ProfileWatchdogRules extends Model {
  get formatters () {
    return {
      rules: dataArray => dataArray.map(data => new TierWatchdogRule(data))
    }
  }

  get schema () {
    return [
      'tier',
      'ruleGroupId',
      'rules'
    ]
  }
}

export default ProfileWatchdogRules
